module.exports = __webpack_public_path__ + "img/main-gallery3.2163aebf.jpg";